import { createSelector } from 'reselect';
import { prop } from 'ramda';

export const getFnol = prop('fnol');

export const getThirdPartyDetails = createSelector(getFnol, prop('thirdPartyDetails'));
